//\u00e9
export const ratings = {
    "Ohio State": 29.1293924295241,
    "Texas Tech": 27.4022856208998,
    "Georgia": 27.3579375728851,
    "Texas A&M": 25.051643745253,
    "Indiana": 30.0509895213904,
    "Alabama": 24.6806421337485,
    "Oklahoma": 23.0815772933583,
    "Oregon": 22.3072390191567,
    "Utah": 21.4679607045135,
    "Notre Dame": 20.9469774719188,
    "Ole Miss": 20.9206527224749,
    "Texas": 20.3440712882358,
    "Vanderbilt": 20.2545742534064,
    "Tennessee": 19.2103080401592,
    "Missouri": 17.9388509334273,
    "Penn State": 16.93372813112,
    "Miami": 16.9200388188147,
    "Iowa": 16.8750856199313,
    "LSU": 16.2699258388971,
    "Auburn": 16.1218054888971,
    "Michigan": 14.6336303777724,
    "USC": 14.3493312884215,
    "James Madison": 14.0757231050301,
    "Arkansas": 13.8089012875701,
    "BYU": 13.4655018963093,
    "Illinois": 11.6195891315124,
    "South Florida": 11.5613549745114,
    "Arizona": 11.5296902453671,
    "Florida": 11.3703714411727,
    "Mississippi State": 10.8509834369388,
    "Washington": 10.6909887457106,
    "SMU": 10.2135002631917,
    "Arizona State": 10.0056692080502,
    "Louisville": 9.04311840146727,
    "Georgia Tech": 8.71523194577504,
    "Florida State": 8.48261480520532,
    "North Texas": 6.26329563999511,
    "TCU": 8.18426272052826,
    "Kentucky": 7.942795995774,
    "Clemson": 7.86955811904636,
    "Nebraska": 7.82809675499221,
    "South Carolina": 7.74192883045278,
    "Pittsburgh": 7.62134691704711,
    "Kansas State": 7.49446092023149,
    "Washington State": 6.30468981465247,
    "Virginia": 4.233209097766,
    "Memphis": 6.05449046478014,
    "Houston": 5.56508954024346,
    "Old Dominion": 5.06034655789237,
    "Baylor": 4.9323679733834,
    "Kansas": 4.81923251379895,
    "San Diego State": -4.57302667132676,
    "Duke": 4.56993114527914,
    "Tulane": 6.33761144961798,
    "Cincinnati": 4.05039234935882,
    "Wake Forest": 3.42247766444173,
    "Northwestern": 3.33893083679864,
    "Iowa State": 2.74317499590553,
    "Toledo": 2.39318895137903,
    "West Virginia": 2.26325862561377,
    "New Mexico": -3.77871241147491,
    "Wisconsin": 1.68611951923686,
    "Boise State": 5.42910031073776,
    "NC State": 0.700225608028949,
    "Minnesota": 0.49683927981452,
    "East Carolina": 0.202725698981751,
    "FCS": 0,
    "Michigan State": -0.319634186942786,
    "Rutgers": -1.11008230518718,
    "Maryland": -1.25267961646087,
    "Colorado": -2.02377351447507,
    "UNLV": -2.05583878930436,
    "UTSA": -2.29514288567649,
    "UConn": -2.48789816663683,
    "Western Kentucky": -2.85528562688428,
    "UCF": -3.02913906649792,
    "Utah State": -3.19023241680695,
    "Navy": -3.40320240244196,
    "UCLA": -3.76738353229272,
    "Fresno State": -3.90494372695256,
    "Virginia Tech": -4.1786418168874,
    "Marshall": -4.57455897414999,
    "Texas State": -4.73244761843456,
    "Army": -5.20542589339937,
    "California": -5.24724794419252,
    "Southern Miss": -5.44682459488869,
    "North Carolina": -5.54397430400438,
    "Western Michigan": -5.89995003648841,
    "Louisiana Tech": -6.3703000804801,
    "Purdue": -6.63667226956805,
    "Ohio": -6.67137013885625,
    "Kennesaw State": -7.07605631760664,
    "Hawai'i": -7.70758087720387,
    "Boston College": -7.95556978571713,
    "Jacksonville State": -8.00348044833516,
    "San Jos\u00e9 State": -8.6771874832851,
    "Troy": -8.9426647904887,
    "Air Force": -9.18336727073555,
    "Georgia Southern": -9.37610960460708,
    "Miami (OH)": -9.45761424609225,
    "Stanford": -9.4727714201907,
    "Missouri State": -9.58369113530197,
    "Florida Atlantic": -9.89037029496922,
    "Temple": -9.90458492234031,
    "Liberty": -10.2885512536844,
    "Arkansas State": -10.7810972429648,
    "South Alabama": -10.9516639486629,
    "App State": -11.3131856152422,
    "Central Michigan": -11.689256730514,
    "Florida International": -11.7448670059057,
    "Oregon State": -12.6027498454094,
    "Colorado State": -12.6476009527903,
    "Tulsa": -13.0568361707917,
    "Oklahoma State": -13.4698011755409,
    "Delaware": -13.4703499480119,
    "New Mexico State": -13.5182716711907,
    "Syracuse": -13.5264302225034,
    "Bowling Green": -13.6069192377442,
    "Wyoming": -13.7671355132587,
    "Buffalo": -14.0760980437263,
    "Middle Tennessee": -14.7837773976154,
    "Nevada": -15.5289149999143,
    "Eastern Michigan": -15.6650927489673,
    "Coastal Carolina": -16.0717107870375,
    "Rice": -16.6711151996241,
    "UTEP": -16.879337889638,
    "Northern Illinois": -18.8627200162095,
    "Louisiana": -19.0005627580056,
    "Georgia State": -19.0635360406407,
    "UL Monroe": -19.9282825481522,
    "UAB": -20.0166305724734,
    "Kent State": -21.0448003554224,
    "Akron": -23.4454890717095,
    "Charlotte": -23.6284389847968,
    "Sam Houston": -24.7519656002792,
    "Ball State": -24.9574718769309,
    "Massachusetts": -32.9216165372769,

                         };